import { ref } from 'vue'

export const currentNewManager = ref(null)
